// LedgerEvent describes all on-chain events related to Erdstall, which are emitted
// by the ledger backends.
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLedgerEvent = void 0;
const event = [
    "Frozen",
    "Deposited",
    "Withdrawn",
    "Challenged",
    "ChallengeResponded",
    "TokenTypeRegistered",
    "TokenRegistered",
];
function isLedgerEvent(v) {
    return event.includes(v);
}
exports.isLedgerEvent = isLedgerEvent;
//# sourceMappingURL=event.js.map